import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from './userReducer';

const initialState = null;

const blogsLastEvaluatedKeyReducer = createSlice({
    name: 'blogsLastEvaluatedKey',
    initialState: null,
    reducers: {
        setBlogsLastEvaluatedKeyData(state, action) {
            return action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(revertAll, () => initialState);
    },
});

export const { setBlogsLastEvaluatedKeyData } = blogsLastEvaluatedKeyReducer.actions;
export default blogsLastEvaluatedKeyReducer;